import { API } from '@Providers';
import type { RtoFeePayload } from '../interfaces';

export default async function (payload: RtoFeePayload) {
  const endpoint = '/api/shelter/animal/update-single-animal-rto-fee';

  if (!payload.rto_fee_id) delete payload.rto_fee_id;

  return API({ endpoint, method: 'put', payload });
}
